import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';

const CategorySelector = ({ ariaLabel = 'News categories', basePath = '/news', categories }) => {
    if (!categories || !categories.length) return null;

    return (
        <nav className="category-selector" aria-label={ariaLabel}>
            <div className="constrain-width large">
                <div className="category-selector-inner">
                    {categories.map(({ id, name, slug }) => (
                        <NavLink
                            key={id}
                            to={`${basePath}/${slug}`}
                            className={({ isActive }) => classnames('button', { 'is-active': isActive })}
                        >
                            {name}
                        </NavLink>
                    ))}
                </div>
            </div>
        </nav>
    );
};

CategorySelector.propTypes = {
    ariaLabel: PropTypes.string,
    basePath: PropTypes.string,
    categories: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        slug: PropTypes.string
    }))
};

export default CategorySelector;
